import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { selectCurrentSalonId, selectCurrentSalonNewPricing, selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const L = logger('PlanCost');

// Essential plan pricing
const ESSENTIAL_BASE = 20;
const ESSENTIAL_PER_COLUMN = 12;

// Advanced plan pricing
const ADVANCED_BASE = 35;
const ADVANCED_PER_COLUMN = 18;

const PlanCost = ({ stylists, salonId, fetchStylistsBySalon }) => {
  const columns = isFullArray(stylists) ? stylists.filter((s) => s.status !== 'deleted' && !s.serves_as_waitlist && s.has_column).length : 0;

  const essentialPrice = columns > 0 ? ESSENTIAL_BASE + (columns - 1) * ESSENTIAL_PER_COLUMN : 0;

  const advancedPrice = columns > 0 ? ADVANCED_BASE + (columns - 1) * ADVANCED_PER_COLUMN : 0;

  const upgradeDifference = advancedPrice - essentialPrice;

  useEffect(() => {
    void L.unignore('useEffect()', 'fetchStylistsBySalon:', fetchStylistsBySalon(salonId));
  }, [fetchStylistsBySalon, salonId]);

  return (
    <div data-bem="PlanCost">
      <Space>
        <CurrencySign value={upgradeDifference} />
      </Space>
    </div>
  );
};

const mapStateToProps = (state) => ({
  stylists: selectCurrentSalonStylists(state),
  salonId: selectCurrentSalonId(state),
  isNewPricing: selectCurrentSalonNewPricing(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchStylistsBySalon }, dispatch);

const PlanCostHoc = connect(mapStateToProps, mapDispatchToProps)(PlanCost);

export default PlanCostHoc;
